<script>
import _ from 'lodash'
// import utils from '@/lib/utils'
import { createNamespacedHelpers } from 'vuex'
import { QSelect } from 'quasar'
import FieldIconMixin from './FieldIconMixin.js'
import FieldProxyMixin from './FieldProxyMixin.js'
import FieldSelectMixin from './FieldSelectMixin.js'
import FieldDenseMixin from './FieldDenseMixin'
import IBtn from '../ext/IBtn.vue'

const { mapGetters, mapActions } = createNamespacedHelpers('bis/dic')

export default {
  mixins: [FieldIconMixin, FieldProxyMixin, FieldSelectMixin, FieldDenseMixin],
  props: {
    dic: {
      required: true,
      type: String
    },
    dicParent: [Number, String],
    inline: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selectOptions: null,
      inputValue: null,
      actions: {
        add: {
          loading: false,
          disable: false
        }
      }
    }
  },
  computed: {
    ...mapGetters(['modelsOptions', 'modelsOptionsByParentId', 'modelIcon', 'modelLabel', 'modelRequireParent', 'modelAddHandler']),
    // override PrependIconMixin
    computedPrependIcon () {
      return this.prependIcon ?? this.modelIcon(this.dic)
    },
    // override FieldSelectMixin
    allOptions () {
      // TODO: 是否响应式？
      return this.modelRequireParent(this.dic) && !_.isNil(this.dicParent)
        ? (this.modelsOptionsByParentId(this.dic, this.dicParent) ?? [])
        : (this.modelsOptions(this.dic) ?? [])
    },
    computedLabel () {
      return this.label ?? this.modelLabel(this.dic)
    },
    addHandler () {
      // this.dic
      return this.modelAddHandler && this.dic && this.modelAddHandler(this.dic)
    }
  },
  async created () {
    await this.loadModels({ modelName: this.dic })
    this.selectOptions = this.validOptions
  },
  render (createElement) {
    const useInput = this.useInput ?? true
    const label = this.computedLabel
    const inputValue = this.inputValue?.trim()
    const inputValueUpperCase = inputValue?.toUpperCase()
    const presetScopedSlots = {
      prepend: this.slotPrependIcon(createElement),
      option: this.slotOption(createElement),
      'selected-item': this.slotSelectedItem(createElement)
    }
    if (!this.disable && this.$refs.input && this.addHandler) {
      if (useInput && inputValue && !this.selectOptions.find(item => this.$refs.input.getOptionLabel(item)?.trim()?.toUpperCase() === inputValueUpperCase)) {
        const that = this
        presetScopedSlots.append = function () {
          return createElement(IBtn, {
            props: {
              glossy: false,
              round: true,
              dense: true,
              flat: true,
              icon: 'add_circle',
              tooltipText: `新增${label}(${inputValue})`,
              ...that.actions.add
            },
            on: {
              click () {
                if (inputValue) {
                  that.addWord(inputValue)
                }
              }
            }
          })
        }
      }
    }
    return createElement(QSelect, {
      ref: 'input',
      props: {
        ...this.$props,
        dense: this.computedDense,
        useInput: useInput,
        hideSelected: this.hideSelected ?? useInput,
        fillInput: this.fillInput ?? useInput,
        options: this.selectOptions,
        label: label,
        useChips: this.multiple,
        disable: false,
        readonly: this.disable || this.readonly
      },
      attrs: {
        ...this.$attrs
      },
      on: Object.assign({
        filter: (val, update) => {
          this.onFilterOptions(val, update)
        },
        'input-value': (val) => {
          this.inputValue = _.isNil(val) ? '' : String(val)
        }
      }, this.$listeners),
      scopedSlots: Object.assign(presetScopedSlots, this.$scopedSlots)
    })
  },
  methods: {
    ...mapActions(['loadModels']),
    async addWord (dicText) {
      if (!dicText) {
        this.$q.notify({ type: 'warning', message: `未指定待添加的新 ${this.computedLabel} 名称` })
        return
      }
      this.actions.add.loading = true
      this.actions.add.disable = true
      const sort = (_.max(this.allOptions, option => option.model?.sort ?? 0)?.model?.sort ?? 0) + 1
      const response = this.addHandler({ dicText, sort, parentId: this.dicParent })
      const result = response instanceof Promise ? (await response) : response
      result.notify(result.success ? `新增${this.computedLabel}(${dicText})成功` : null)
      if (result.success) {
        await this.loadModels({ modelName: this.dic, force: true })
        const emittingOptionValue = this.$refs.input.getEmittingOptionValue(result.data.id)
        console.log('emittingOptionValue', emittingOptionValue, result)
        this.$emit('input', emittingOptionValue)
      }
      this.actions.add.loading = false
      this.actions.add.disable = false
    }
  }
}
</script>
